module.exports = __webpack_public_path__ + "img/Harry Bartlett Still III.60398c45.jpg";